import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../lib/auth-context.js'
import { type EphemeralSession, getActiveEphemeralSession } from '../lib/ephemeral-session.js'

/**
 * 暫定テナントセッション中に表示する固定バナー。
 *
 * - 残時間カウントダウン
 * - 上限制約（プロジェクト1件・8GB・共有URL1本）
 * - 「無料プランに登録してデータを引き継ぐ」CTA
 *
 * Supabase ログイン中は表示しない（getActiveEphemeralSession と同じ優先順位）。
 */
export function EphemeralBanner() {
  const { session } = useAuth()
  const ephemeralSession = getActiveEphemeralSession(!!session)
  const [remaining, setRemaining] = useState<string>(formatRemaining(ephemeralSession))

  useEffect(() => {
    if (!ephemeralSession) return
    const id = setInterval(() => {
      setRemaining(formatRemaining(ephemeralSession))
    }, 60_000)
    return () => clearInterval(id)
  }, [ephemeralSession])

  if (!ephemeralSession) return null

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 text-yellow-900 px-4 py-2">
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-3 text-sm">
        <span>
          24時間お試し中 · 残り {remaining} ·{' '}
          <span className="text-xs">お試し中の上限：1プロジェクト・8GB・共有URLは1本まで</span>
        </span>
        <Link
          to="/signup"
          className="text-sm bg-yellow-900 text-yellow-50 px-3 py-1 rounded-md font-medium"
        >
          無料プランに登録（データ引き継ぎ）
        </Link>
      </div>
    </div>
  )
}

function formatRemaining(session: EphemeralSession | null): string {
  if (!session) return '—'
  const ms = new Date(session.expiresAt).getTime() - Date.now()
  if (ms <= 0) return '0分'
  const hours = Math.floor(ms / (60 * 60 * 1000))
  const mins = Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000))
  if (hours > 0) return `${hours}時間${mins}分`
  return `${mins}分`
}
